import classNames from 'classnames';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { AttachmentCommentMeta } from 'api/conversations';
import { RoutePaths } from 'constant';
import { extname, isImageUrlFromExtension } from 'utils/files';
import styles from '../file-thumbnail.module.css';

export const AttachmentCommentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100%;
`;

export const AttachmentMetaWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: var(--spacing-03);
`;

export const AttachmentMetaTextWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  margin-left: var(--spacing-04);
`;

export const AttachmentThumbnail = styled.img`
  height: var(--spacing-07);
  width: 50px;
`;

interface AttachmentVersionMessageProps {
  comment: AttachmentCommentMeta;
  keyForString: string;
}

export const AttachmentVersionMessage: FC<AttachmentVersionMessageProps> = ({
  comment,
  keyForString,
}) => {
  const fileExtension = extname(
    comment.meta.attachment.location || comment.meta.attachment.name,
  );
  const isImage = isImageUrlFromExtension(
    comment.meta.attachment.location || comment.meta.attachment.name,
  );

  const itemClass = classNames(
    styles.item,
    !isImage && styles.item__other,
    fileExtension === 'pdf' && styles.item__pdf,
    (fileExtension === 'csv' || fileExtension === 'xlsx') && styles.item__csv,
    fileExtension === 'pptx' && styles.item__ppt,
    fileExtension === 'docx' && styles.item__docs,
  );

  return (
    <AttachmentCommentWrapper>
      <FormattedMessage
        id={keyForString}
        values={{
          fileName: comment?.meta?.attachment?.name,
          changedByUserName: comment?.meta?.changedByUserName,
        }}
      />
      {comment.meta.changeType === 'REMOVED' ? null : (
        <AttachmentMetaWrapper>
          {isImage ? (
            <AttachmentThumbnail
              src={comment?.meta?.attachment?.location}
              alt={comment?.meta?.attachment?.name}
              height="100px"
              width="100%"
            />
          ) : (
            <div className={itemClass} role="button" tabIndex={0}>
              <h6 className="h6">{fileExtension}</h6>
            </div>
          )}
          <AttachmentMetaTextWrapper>
            <Link
              to={RoutePaths.attachmentWorkspace.replace(
                ':attachmentId',
                comment?.meta?.attachment?.attachmentId.toString(),
              )}
            >
              <FormattedMessage id="view_version" />
            </Link>
          </AttachmentMetaTextWrapper>
        </AttachmentMetaWrapper>
      )}
    </AttachmentCommentWrapper>
  );
};
